"use client";

import { CoinInfoWidget } from "@/components/app/app-layout/coin-info-widget";
import { SidebarTopResultsWidget } from "@/components/app/app-layout/sidebar-top-resutls-widget/sidebar-top-results-widget";
import { useLayout } from "@/contexts/layout-context";

import SidebarBalancesWidget from "./sidebar-balances-widget";

const DiscoverWidget = () => <SidebarTopResultsWidget />;

export const RightSidebarWidgets = () => {
  const { discoveryWidget, coinInfoWidget } = useLayout();

  return (
    <div className="flex flex-col gap-4 pb-4">
      {coinInfoWidget ? (
        <CoinInfoWidget
          fallback={
            <>
              <SidebarBalancesWidget />
              <DiscoverWidget />
            </>
          }
        />
      ) : (
        <SidebarBalancesWidget />
      )}
      {discoveryWidget && <DiscoverWidget />}
    </div>
  );
};
